import React from "react";
import { COLOR_SYSTEM } from "components/design/design-system";
import { ButtonType } from "components/atoms/Button";
import Icon from "components/atoms/Icon";
import {
  IconFloatingButtonWrapper,
  IconWithTextFloatingButtonWrapper,
  TextFloatingButtonWrapper,
} from "components/atoms/FloatingButton/style";

export type FloatingButtonSize = "XLarge" | "Large" | "Medium";
export type FloatingButtonUsage = "Primary" | "Secondary" | "Tertiary";

export interface FloatingButtonProps {
  /** 버튼 크기 */
  size: FloatingButtonSize;
  /** 버튼 타입 */
  type: ButtonType;
  /** 버튼 색상 */
  color: FloatingButtonUsage;
  /** 버튼 안에 들어가는 content */
  children?: React.ReactNode | string;
  /** 아이콘 위치 여부(택스트 앞) */
  left?: boolean;
  /** 아이콘 위치 여부(택스트 뒤) */
  right?: boolean;
  /** 아이콘 */
  icon?: string;
  /** 아이콘 크기 */
  iconSize?: number;
  /** 클릭 이벤트 핸들러 */
  onClick: (params?: any) => any;
}

const FloatingButton = ({
  size,
  type,
  color,
  children,
  left,
  right,
  icon,
  iconSize,
  onClick,
}: FloatingButtonProps) => {
  const iconSizeMap = {
    XLarge: 24,
    Large: 24,
    Medium: 20,
  };

  const iconColorMap = {
    Primary: COLOR_SYSTEM.get("Gray")?.[0],
    Secondary: COLOR_SYSTEM.get("Gray")?.[0],
    Tertiary: COLOR_SYSTEM.get("Gray")?.[400],
  };

  const renderByType = () => {
    switch (type) {
      case "Icon":
        return (
          <IconFloatingButtonWrapper
            color={color}
            size={size}
            buttonType={type}
            onClick={onClick}
          >
            {icon && (
              <Icon
                name={icon}
                color={iconColorMap[color]}
                size={iconSize || iconSizeMap[size]}
              />
            )}
          </IconFloatingButtonWrapper>
        );
      case "Text":
        return (
          <TextFloatingButtonWrapper
            color={color}
            size={size}
            buttonType={type}
            onClick={onClick}
          >
            {children}
          </TextFloatingButtonWrapper>
        );
      case "IconWithText":
        return (
          <IconWithTextFloatingButtonWrapper
            color={color}
            size={size}
            buttonType={type}
            left={left}
            right={right}
            onClick={onClick}
          >
            {left && icon && (
              <Icon
                name={icon}
                color={iconColorMap[color]}
                size={iconSize || iconSizeMap[size]}
              />
            )}
            {children}
            {right && icon && (
              <Icon
                name={icon}
                color={iconColorMap[color]}
                size={iconSize || iconSizeMap[size]}
              />
            )}
          </IconWithTextFloatingButtonWrapper>
        );
    }
  };

  return <>{renderByType()}</>;
};

export default FloatingButton;
